define(() => {
    "use strict";

    const COPY_CODE_BUTTON_STATE = "copyCodeButtonState";

    const BUTTON_STATUS = {
        enabled: "ENABLED",
        disabled: "DISABLED"
    };

    return {
        COPY_CODE_BUTTON_STATE,
        BUTTON_STATUS
    };
});



// WEBPACK FOOTER //
// ./src/shared/util/copyCode.js